import { useEffect, useState } from 'react';
import heroDevsecopsImage from '../../../assets/images/heroDevsecops.jpg';

export default function HeroSection() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    setIsVisible(true);
    
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollToContact = () => {
    const ctaSection = document.getElementById('cta-section');
    if (ctaSection) {
      ctaSection.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section className="relative min-h-screen bg-gradient-to-br from-[#2a4b7c] via-[#1f3a5f] to-[#1a3557] overflow-hidden">
      {/* Background decorative elements */}
      <div className="absolute inset-0 opacity-10">
        <div className="absolute top-20 left-10 w-72 h-72 bg-[#06b6d4] rounded-full blur-3xl"></div>
        <div className="absolute bottom-20 right-10 w-96 h-96 bg-[#00b587] rounded-full blur-3xl"></div>
      </div>

      <div className="relative max-w-[1440px] mx-auto px-4 md:px-8 lg:px-20 pt-20 md:pt-32 pb-12 md:pb-24 flex items-center min-h-screen">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-8 md:gap-12 lg:gap-16 items-center w-full">
          {/* Left Column - Text Content */}
          <div className={`space-y-6 md:space-y-8 transition-all duration-1000 ${isVisible ? 'opacity-100 translate-x-0' : 'opacity-0 -translate-x-10'}`}>
            <div className="space-y-4 md:space-y-6">
              <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold text-white leading-tight">
                Triển khai{' '}
                <span className="bg-gradient-to-r from-[#06b6d4] to-[#00b587] bg-clip-text text-transparent">
                  DevSecOps
                </span>
                <br />
                cho Doanh nghiệp
              </h1>
              <p className="text-lg md:text-xl text-white/85 leading-relaxed">
                Tích hợp bảo mật ngay từ đầu. Vận hành phần mềm an toàn, linh hoạt và bền vững.
              </p>
            </div>

            <p className="text-sm md:text-base text-white/70 leading-relaxed max-w-[520px]">
              DevSecOps không chỉ là công cụ hay pipeline, mà là cách doanh nghiệp xây dựng, phát hành và vận hành phần mềm một cách chủ động và kiểm soát rủi ro.
            </p>

            <div className="pt-2 md:pt-4">
              <button 
                onClick={scrollToContact}
                className="group px-6 md:px-10 py-3 md:py-4 bg-gradient-to-r from-[#06b6d4] to-[#00b587] text-white text-base md:text-lg font-semibold rounded-xl hover:shadow-2xl hover:shadow-[#06b6d4]/30 transition-all duration-300 hover:-translate-y-1 flex items-center gap-2 md:gap-3 cursor-pointer w-full md:w-auto justify-center"
              >
                Nhận tư vấn DevSecOps
                <i className="ri-arrow-right-line text-lg md:text-xl group-hover:translate-x-1 transition-transform"></i>
              </button>
            </div>
          </div>

          {/* Right Column - Visual */}
          <div className={`relative transition-all duration-1000 delay-300 ${isVisible ? 'opacity-100 translate-x-0' : 'opacity-0 translate-x-10'}`}>
            <div className="relative bg-white/8 backdrop-blur-sm rounded-2xl md:rounded-3xl p-6 md:p-8 lg:p-12 border border-white/10">
              <img 
                src={heroDevsecopsImage}
                alt="DevSecOps Pipeline Visualization"
                className="w-full h-auto rounded-2xl"
              />
              
              {/* Floating elements */}
              <div className="absolute -top-3 -right-3 md:-top-6 md:-right-6 w-16 h-16 md:w-24 md:h-24 bg-gradient-to-br from-[#06b6d4] to-[#00b587] rounded-xl md:rounded-2xl flex items-center justify-center shadow-xl animate-bounce">
                <i className="ri-shield-check-line text-2xl md:text-4xl text-white"></i>
              </div>
              
              <div className="absolute -bottom-2 -left-2 md:-bottom-4 md:-left-4 w-16 h-16 md:w-20 md:h-20 bg-white/10 backdrop-blur-sm rounded-lg md:rounded-xl flex items-center justify-center border border-white/20">
                <i className="ri-cloud-line text-2xl md:text-3xl text-[#06b6d4]"></i>
              </div>
            </div>

            {/* Decorative dots */}
            <div className="absolute top-0 right-0 w-24 h-24 md:w-32 md:h-32 opacity-20 hidden md:block">
              <div className="grid grid-cols-4 gap-2">
                {[...Array(16)].map((_, i) => (
                  <div key={i} className="w-2 h-2 bg-[#06b6d4] rounded-full"></div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Scroll indicator */}
      <div className="absolute bottom-8 left-1/2 -translate-x-1/2 animate-bounce">
        <i className="ri-arrow-down-line text-3xl text-white/50"></i>
      </div>
    </section>
  );
}
